/* External */
import {
  memo, useCallback, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import CommonPreSearchCard from '@dtvgo/pre-search-card';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { LANDER_LOGO_BASE_IMAGE_URL, ImageRatio } from '../../utils/constants';
import { isLanderCollection } from '../../utils/metaDataUtils';
import { sizeByViewport } from '../../utils/cardsUtils';

/* Hooks */
import useImageCard from '../../hooks/useImageCard';

/* Styles */
import './PreSearchCard.scss';

const IMG_WIDTH = sizeByViewport(350);
const IMG_DIMENSION = ImageRatio.SIXTEEN_BY_NINE;

function PreSearchCard({
  className = '',
  item: collection,
  focused = false,
  index,
  onMouseDown = undefined,
  onMouseEnter = undefined,
}) {
  const { title, cardImages, backGroundImages } = collection;
  const imagesToUse = backGroundImages || cardImages;
  const { imageUrl } = useImageCard({
    images: imagesToUse,
    imageSize: IMG_WIDTH,
    aspectRatio: IMG_DIMENSION,
  });

  const [isErrorLanderLogo, setIsErrorLanderLogo] = useState(false);
  const isLander = useMemo(() => isLanderCollection(collection), [collection]);

  const handleLanderLogoError = useCallback(() => {
    setIsErrorLanderLogo(true);
  }, []);

  return (
    <CommonPreSearchCard
      className={`dtv-html5-c-pre-search-card ${focused ? 'dtv-html5-c-pre-search-card--focused' : ''} ${className}`}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      index={index}
    >
      <img className="dtv-html5-c-pre-search-card__background-img" alt="" src={imageUrl} />
      <span className="dtv-html5-c-pre-search-card__background" />
      {!isLander || isErrorLanderLogo ? (
        <CommonPreSearchCard.Title>
          {title || ''}
        </CommonPreSearchCard.Title>
      ) : (
        <CommonPreSearchCard.Logo
          title={title.replace(/\+$/, '')} // remove plus character
          baseImageUrl={LANDER_LOGO_BASE_IMAGE_URL}
          onError={handleLanderLogoError}
        />
      )}
    </CommonPreSearchCard>
  );
}

PreSearchCard.propTypes = {
  focused: PropTypes.bool,
  index: PropTypes.number.isRequired,
  item: PropTypes.shape().isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  className: PropTypes.string,
};

export default memo(withInteractiveFocusable()(memo(PreSearchCard)));
